import { useState } from "react";
import { RowSelectionState } from "@tanstack/react-table";

export const useDataTableSelection = (initialState: RowSelectionState) => {
  return useState<RowSelectionState>(initialState);
};
